import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://hotelapi.shriyanshnath.com",
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
